export default "__VITE_ASSET__CJTdn9XY__"